import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import PropTypes from "prop-types";


export default function HomePageLayout({ children }) {
  return (
    <>
      {/* <Outlet /> */}

      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

HomePageLayout.propTypes = { children: PropTypes.node };
